import React from 'react'
import { PostBodyStyle } from './style'

const PostBody = ({ postText }: any) => {
  return <PostBodyStyle>{postText}</PostBodyStyle>
}

export default PostBody
